<template>
  <div class="content">
    <div class="background-image-search" style="background-image: url(img/temp/blurred-dark.jpg"></div>
    <!-- /.background-image-search -->

    <base-header class="pb-6" type="none">
      <b-row align-v="center" class="py-4">
        <b-col xs="12" lg="6">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
        <b-col xs="12" lg="6" align="right">
          <router-link to="/tag/add-tag"><base-button type="secondary" size="sm" class="btn-secondary--alt">Add Tag</base-button></router-link>
          <router-link to="/recipe/add-recipe"><base-button type="secondary" size="sm" class="btn-secondary--alt">Add Recipe</base-button></router-link>
        </b-col>
      </b-row>
    </base-header>
    <b-container class="container--md mt--6">
      <div>
        <card class="no-border-card mt-2 card-results" header-classes="pb-1" body-classes="px-0 pt-0 pb-0" footer-classes="pb-2">
          <template slot="header">
            <b-row align-h="end">
              <b-col cols="3">
                <form>
                  <base-input type="search"
                              v-model="sq"
                              placeholder="Search Tags"
                              @keydown.native="search($event)" 
                              @input.native="search($event)">
                  </base-input>
                </form>
              </b-col>
              <b-col cols="6" class="align-items-left">
                <!-- <p class="mb-0 mr-2 text-sm" v-if="filterShow">{{ filterShow }}</p> -->

                <!-- <el-select class="select-primary pagination-select" v-model="pagination.perPage" placeholder="Per page">
                  <el-option class="select-primary" v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                  </el-option>
                </el-select> -->

                <!-- <p class="mb-0 ml-2 text-sm" v-if="filterEntries">{{ filterEntries }}</p> -->
              </b-col>
              <b-col cols="3">
                
              </b-col>
            </b-row>
          </template>
          <div>
            <div v-show="this.loading" class="loading">
              <loading-panel></loading-panel>
            </div>
            <el-table :data="tags"
              row-key="id"
              header-row-class-name="thead-light"
              class="table-results"
              v-if="view === 'table'">

              <el-table-column label="Result title" min-width="440px" prop="name" sortable>
                <template v-slot="{ row }">
                  <b-media no-body class="align-items-center">
                    <a v-if="row.isVisible == true" :href="'/tag/' + row.id" class="avatar mr-3 table__avatar" :class="(!row.icon)?'avatar--grey':' rounded-circle'">
                      <b-img alt="Image placeholder" :src="row.icon.absoluteUri" v-if="row.icon"></b-img>
                      <span v-if="!row.icon">{{ row.name ? row.name.charAt(0) : '...' }}</span>
                    </a>
                    <a v-if="row.isVisible == false" :href="'/tag/' + row.id" class="avatar mr-3 table__avatar" :class="(!row.icon)?'avatar--grey':' rounded-circle'">
                      <b-img alt="Image placeholder" :src="row.icon.absoluteUri" v-if="row.icon"></b-img>
                      <span v-if="!row.icon">{{ row.name ? row.name.charAt(0) : '...' }}</span>
                    </a>
                    <b-media-body class="table__title-wrapper">
                      <a :href="'/tag/' + row.id">
                        <span class="font-weight-600 name mb-0 text-sm">{{ row.name ? row.tagGroup.name + ' > ' + row.name : 'Loading...' }}</span>
                      </a>
                    </b-media-body>
                  </b-media>
                </template>
              </el-table-column>

              <el-table-column label="Public Facing" min-width="175px" prop="status" sortable>
                <template v-slot="{ row }">
                  <badge class="badge-dot mr-4" type="inherit">
                    <i :class="`bg-${row.statusCode}`"></i>
                    <span class="status font-weight-600">{{ row.isVisible == 1 ? 'True' : 'False' }}</span>
                  </badge>
                </template>
              </el-table-column>

              <!--
              <el-table-column label="Active" prop="isActive" sortable>
                <template v-slot="{row}">
                  <base-switch label="Is Active?"
                          name="isActive"
                          class="mr-1" 
                          on-text="Yes" 
                          off-text="No" 
                          v-on:input="toggleActive(row, row.isActive)"
                          v-model="row.isActive">
                  </base-switch>
                </template>
              </el-table-column>
              -->

              <el-table-column label="Author" min-width="176px" prop="author" sortable>
                <template v-slot="{row}">
                  <b-img :src="row.user && row.user.image ? row.user.image.absoluteUri : 'img/DefaultUser.gif'" rounded="circle" class="avatar-sm mr-2"/>
                </template>
              </el-table-column>

              <el-table-column min-width="94px" align="last" label="Actions">
                <template v-slot="{ $index, row }" v-if="this.$store.getters.userIsAdmin">
                  <el-dropdown trigger="click" class="dropdown">
                    <span class="btn btn-sm btn-icon-only text-light mr-0">
                      <i class="fas fa-ellipsis-v mt-2"></i>
                    </span>
                    <el-dropdown-menu class="dropdown-menu dropdown-menu-arrow show" slot="dropdown">
                      <!--<b-dropdown-item>View</b-dropdown-item>-->
                      <b-dropdown-item @click.native="handleEdit(row.id)">Edit</b-dropdown-item>
                      <b-dropdown-item @click.native="handleDelete($index, row)">Delete</b-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
            <div class="">
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ count }} entries
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              :current="currentPage"
              :per-page="perPage"
              :total="count"
              @change="paginationChanged($event)"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </b-container>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option, DropdownMenu, DropdownItem, Dropdown, Checkbox } from 'element-ui';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import { BasePagination } from '@/components';
// import clientPaginationMixin from '@/views/Tables/PaginatedTables/clientPaginationMixin';
import swal from 'sweetalert2';
import BaseSwitch from '../../components/BaseSwitch.vue';
import LoadingPanel from '@/components/LoadingPanel.vue';

export default {
  // mixins: [clientPaginationMixin],
  components: {
    BasePagination,
    RouteBreadCrumb,
    BaseSwitch,
    LoadingPanel,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Checkbox.name]: Checkbox
  },
  data() {
    return {
      propsToSearch: ['name', 'description', 'brand'],
      itemLimit: '10',
      view: 'table', 
      sq: this.$route.query.sq,
      sortBy: 1,
      loading: '',
      pauseSearch: false,
      perPage: 25,
      currentPage: 1,
      perPageOptions: [5, 10, 25, 50],
    };
  },
  computed: {
     payload() {
       const searchPayload = {}
        searchPayload.query = this.sq;
        searchPayload.page = this.currentPage;
        searchPayload.pageSize = this.perPage;
        return searchPayload
     },
     tags() {
         return this.$store.state.tags.all[1];
     },
     isLoading() {
       return this.$store.state.tags.loading;
     },
     to() {
        let highBound = this.from + this.perPage;
        if (this.count < highBound) {
          highBound = this.count;
        }
        return highBound;
      },
      from() {
        return this.perPage * (this.currentPage - 1);
      },
      count() {
         return this.$store.state.tags.all[0];
      }
  },
  methods: {
    dateFormat(date) {
      if (date) {
        var local = new Date(date);
        return local.toLocaleDateString("en-US")
      } else {
        return 'No Date'
      }
    },
    sanitize(htmlToClean) {
      const cleaned = this.$sanitize(htmlToClean);
      if ( cleaned === 'undefined' || cleaned === 'null' ) {
        return '';
      }
      let regex = /(<([^>]+)>)/ig;
      return cleaned.replace(regex, "");
    },
    handleEdit(id) {
      this.$router.push(`/tag/edit-tag/${id}`)
    },
    handleDelete(index,row) {
      swal.fire({
        title: 'Are you sure?',
        text: `You won't be able to revert this!`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Yes, delete it!',
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          const { dispatch } = this.$store;
          dispatch("tags/deleteTag", row.id).then(response => {
            this.tags.splice(index, 1);
            return response;
          })
          .catch(error => {
            return error;
          });
        }
      });
    },
    loadTagPage(event) {
      event.preventDefault();

      let route = 'tag';
      const button = event.target.closest('a');

      if (button) {
        this.$router.push({
          path: route,
          query: {
            id: button.getAttribute('href')
          }
        }).catch(() => {});
      }
    },
    searchTags() {
      const { dispatch } = this.$store;
      dispatch("tags/searchTags",this.payload);
    },
    paginationChanged(page) {
      this.currentPage = page;
      this.searchTags();
    },
    toggleActive(tag, isCompleted) {
      const { dispatch } = this.$store;
      dispatch("tags/updateTag",tag);
    },
    toggleSortBy(event, sortBy) {
        const button = event.target;
        button.classList.add('active')
        this.currentPage = 1;
        this.sortBy = sortBy;

        Array.prototype.filter.call(button.parentNode.children, function(child){
          if (child !== button) {
            child.classList.remove('active')
          }
        });
      },
  },
  created() {
    this.searchTags();
  },
  watch: {
    isLoading (newLoad, oldLoad) {
        this.loading = newLoad
    },
    perPage (val,old) {
      this.currentPage = 1;
      this.searchTags();
    },
    sq: function (val,old) {
      this.sq = val;
      this.currentPage = 1;
        if (!this.pauseSearch) {
          setTimeout(() => {
            this.searchTags();
            this.pauseSearch = false;
          }, 800); // 1 sec delay
        }
        this.pauseSearch = true;
    }
  }
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
</style>
